import { managerDashboardDetailEntries } from "./managerDashboardDetails";

// Bundled Manager Dashboard copy. Guest names, notes and custom labels stay verbatim.
const entries: ReadonlyArray<readonly [string, string, string, string]> = [
  ["occupancy","Occupancy","Auslastung","Obłożenie"],
  ["adr","ADR","ADR","ADR"],
  ["revpar","RevPAR","RevPAR","RevPAR"],
  ["revenueToday","Revenue today","Umsatz heute","Przychód dziś"],
  ["otb7","On the books · 7 days","Buchungsstand · 7 Tage","Stan rezerwacji · 7 dni"],
  ["openIssues","Open issues","Offene Probleme","Otwarte problemy"],
  ["occupancyHint","Occupied rooms on the business date as a share of sellable rooms. Every comparison is against the same date last year (STLY).","Belegte Zimmer am Hoteltag als Anteil der verkaufbaren Zimmer. Verglichen wird mit demselben Datum im Vorjahr (STLY).","Pokoje zajęte w dniu hotelowym jako udział pokoi dostępnych w sprzedaży. Porównanie dotyczy tego samego dnia poprzedniego roku (STLY)."],
  ["bookingsToday","+{{count}} bookings today","+{{count}} Buchungen heute","+{{count}} rezerwacji dziś"],
  ["bookingsToday_one","+{{count}} booking today","+{{count}} Buchung heute","+{{count}} rezerwacja dziś"],
  ["bookingsToday_few","+{{count}} bookings today","+{{count}} Buchungen heute","+{{count}} rezerwacje dziś"],
  ["bookingsToday_many","+{{count}} bookings today","+{{count}} Buchungen heute","+{{count}} rezerwacji dziś"],
  ["bookingsToday_other","+{{count}} bookings today","+{{count}} Buchungen heute","+{{count}} rezerwacji dziś"],
  ["deptsAtRisk","{{count}} departments at risk","Gefährdete Abteilungen: {{count}}","Zagrożone działy: {{count}}"],
  ["deptAtRisk","1 department at risk","1 gefährdete Abteilung","1 zagrożony dział"],
  ["noDeptsAtRisk","No department at risk","Keine gefährdete Abteilung","Brak zagrożonych działów"],
  ["laborCoverage","Labor coverage {{value}}%","Personalabdeckung {{value}}%","Pokrycie zapotrzebowania na personel {{value}}%"],
  ["open","Open {{target}}","{{target}} öffnen","Otwórz: {{target}}"],
  ["performance","Performance","Leistung","Wydajność"],
  ["performanceHint","Bars: revenue posted to folios per day (per month for the year to date), the business date in black. Solid line: occupancy. Dashed line on the shaded zone: occupancy already on the books for the next 7 days.","Balken: täglich auf Konten gebuchter Umsatz (monatlich seit Jahresbeginn); Hoteltag in Schwarz. Durchgezogene Linie: Auslastung. Gestrichelte Linie im schattierten Bereich: gebuchte Auslastung der nächsten 7 Tage.","Słupki: przychód zaksięgowany na rachunkach dziennie (miesięcznie od początku roku); dzień hotelowy na czarno. Linia ciągła: obłożenie. Linia przerywana w zacienionym obszarze: obłożenie z rezerwacji na kolejne 7 dni."],
  ["legendRevenue","Revenue ({{currency}})","Umsatz ({{currency}})","Przychód ({{currency}})"],
  ["legendOtb","On the books","Buchungsstand","Stan rezerwacji"],
  ["days7","7 days","7 Tage","7 dni"],
  ["days30","30 days","30 Tage","30 dni"],
  ["ytd","Year to date","Seit Jahresbeginn","Od początku roku"],
  ["nextOtb","Next 7 days · on the books","Nächste 7 Tage · Buchungsstand","Kolejne 7 dni · stan rezerwacji"],
  ["chartLoading","Loading chart…","Diagramm wird geladen…","Wczytywanie wykresu…"],
  ["chartFailed","Chart unavailable — dashboard failed to load","Diagramm nicht verfügbar — Dashboard konnte nicht geladen werden","Wykres niedostępny — nie udało się wczytać pulpitu"],
  ["chartEmpty","No data for this period","Keine Daten für diesen Zeitraum","Brak danych dla tego okresu"],
  ["revenue","Revenue","Umsatz","Przychód"],
  ["rev7","Revenue · 7 days","Umsatz · 7 Tage","Przychód · 7 dni"],
  ["vsPrior7","{{value}} vs prior 7 days","{{value}} ggü. den vorherigen 7 Tagen","{{value}} względem poprzednich 7 dni"],
  ["bookings7","Bookings · 7 days","Buchungen · 7 Tage","Rezerwacje · 7 dni"],
  ["nToday","{{count}} today","{{count}} heute","{{count}} dziś"],
  ["avgStay","Avg. stay · 28 days","Ø Aufenthalt · 28 Tage","Śr. pobyt · 28 dni"],
  ["leadTime","Lead time · 28 days","Buchungsvorlauf · 28 Tage","Wyprzedzenie rezerwacji · 28 dni"],
  ["otb30","On the books · 30 days","Buchungsstand · 30 Tage","Stan rezerwacji · 30 dni"],
  ["nights","{{value}} nights","{{value}} Nächte","Liczba nocy: {{value}}"],
  ["days","{{value}} days","{{value}} Tage","Liczba dni: {{value}}"],
  ["pacePickup","Pace & pickup","Buchungstempo & Zuwachs","Tempo i przyrost rezerwacji"],
  ["movement","Today's movement","Heutige Bewegungen","Dzisiejszy ruch gości"],
  ["updated","updated {{time}}","aktualisiert {{time}}","aktualizacja {{time}}"],
  ["arrivals","Arrivals","Anreisen","Przyjazdy"],
  ["checkedIn","checked in","eingecheckt","zameldowanych"],
  ["departures","Departures","Abreisen","Wyjazdy"],
  ["checkedOut","checked out","ausgecheckt","wymeldowanych"],
  ["inHouse","In house","Im Haus","W hotelu"],
  ["pastDeparture","{{count}} past departure date","{{count}} nach Abreisedatum","{{count}} po terminie wyjazdu"],
  ["noShows","No-shows","Nichtanreisen","Nieprzyjazdy"],
  ["in7","{{count}} in 7 days","{{count}} in 7 Tagen","{{count}} w ciągu 7 dni"],
  ["cancellations","Cancellations","Stornierungen","Anulowania"],
  ["paymentsToday","Payments today","Zahlungen heute","Dzisiejsze płatności"],
  ["openBalances","Open balances","Offene Salden","Nierozliczone salda"],
  ["rooms","Rooms & inventory","Zimmer & Kontingente","Pokoje i dostępność"],
  ["housekeeping","Housekeeping","Hauswirtschaft","Sprzątanie"],
  ["sellable","Sellable","Verkaufbar","Sprzedawalne"],
  ["readyToSell","Ready to sell","Verkaufsbereit","Gotowe do sprzedaży"],
  ["dirty","Dirty","Schmutzig","Brudne"],
  ["outOfOrder","Out of order","Außer Betrieb","Wyłączone z użytku"],
  ["arrivalNotReady","Arrival rooms not ready","Anreisezimmer nicht bereit","Pokoje przyjazdowe niegotowe"],
  ["groupBlocks","Group blocks · upcoming","Gruppenkontingente · demnächst","Bloki grupowe · nadchodzące"],
  ["nGroups","{{count}} groups","Gruppen: {{count}}","Liczba grup: {{count}}"],
  ["oneGroup","1 group","1 Gruppe","1 grupa"],
  ["byFloor","By floor","Nach Etage","Według piętra"],
  ["nFloors","{{count}} floors","Etagen: {{count}}","Liczba pięter: {{count}}"],
  ["oneFloor","1 floor","1 Etage","1 piętro"],
  ["demandMix","Demand mix","Nachfragestruktur","Struktura popytu"],
  ["segments","Segments","Segmente","Segmenty"],
  ["channels","Channels","Kanäle","Kanały"],
  ["segment","Segment","Segment","Segment"],
  ["channel","Channel","Kanal","Kanał"],
  ["roomNights","Room nights","Zimmernächte","Pokojonoce"],
  ["share","Share","Anteil","Udział"],
  ["total","Total","Summe","Suma"],
  ["last28","last 28 days","letzte 28 Tage","ostatnie 28 dni"],
  ["details","Details","Details","Szczegóły"],
  ["reports","Reports","Berichte","Raporty"],
  ["noStays","No room nights or posted room revenue in the last 28 days","Keine Zimmernächte oder gebuchten Zimmerumsätze in den letzten 28 Tagen","Brak pokojonocy i zaksięgowanego przychodu z pokoi w ostatnich 28 dniach"],
  ["revenueTimingHint","Revenue follows the posting business date; room nights follow stay dates. Late charges and corrections may have revenue without room nights in this period.","Der Umsatz zählt zum Geschäftstag der Buchung; Zimmernächte zählen nach Aufenthaltsdatum. Späte Buchungen und Korrekturen können in diesem Zeitraum Umsatz ohne Zimmernächte ergeben.","Przychód jest liczony według dnia hotelowego księgowania, a pokojonoce według dat pobytu. Późne opłaty i korekty mogą więc mieć kwotę bez pokojonocy w tym okresie."],
  ["loading","Loading…","Wird geladen…","Wczytywanie…"],
  ["needsAttention","Needs attention","Handlungsbedarf","Wymaga uwagi"],
  ["noRisks","No active operational risks","Keine aktiven operativen Risiken","Brak aktywnych ryzyk operacyjnych"],
  ["viewAll","View all","Alle anzeigen","Zobacz wszystko"],
  ["departments","Departments","Abteilungen","Działy"],
  ["departmentsHint","Status and workload are derived from live operations — arrivals, open tasks, incidents and audit exceptions.","Status und Auslastung werden aus dem laufenden Betrieb abgeleitet — Anreisen, offene Aufgaben, Vorfälle und Prüfabweichungen.","Status i obciążenie wynikają z bieżących operacji — przyjazdów, otwartych zadań, incydentów i wyjątków audytu."],
  ["nAtRisk","{{count}} at risk","{{count}} gefährdet","Zagrożone: {{count}}"],
  ["atRisk","At risk","Gefährdet","Zagrożone"],
  ["exc","{{count}} exc.","{{count}} Abw.","Wyjątki: {{count}}"],
  ["noDepartments","No department data for today","Keine Abteilungsdaten für heute","Brak danych działów na dziś"],
  ["brief","Leadership brief","Führungsbriefing","Brief kierowniczy"],
  ["pickupVsYesterday","Pickup vs yesterday","Pickup vs. gestern","Pickup vs wczoraj"],
  ["revenuePace","Revenue pace","Umsatzentwicklung","Tempo przychodu"],
  ["compSet","Comp set index","Comp-Set-Index","Indeks comp set"],
  ["displacement","Displacement","Verdrängung","Wyparcie"],
  ["oneRoom","1 room","1 Zimmer","1 pokój"],
  ["nRooms","{{count}} rooms","Zimmer: {{count}}","Liczba pokoi: {{count}}"],
  ["satisfaction","Guest satisfaction","Gästezufriedenheit","Satysfakcja gości"],
  ["vipToday","VIP today","VIP heute","VIP dziś"],
  ["nInHouse","{{count}} in house","{{count}} im Haus","{{count}} w hotelu"],
  ["complaints","Open complaints","Offene Beschwerden","Otwarte skargi"],
  ["upcomingGroups","Upcoming groups","Kommende Gruppen","Nadchodzące grupy"],
  ["noGroups","No upcoming group blocks","Keine bevorstehenden Gruppenblöcke","Brak nadchodzących bloków grupowych"],
  ["pickedOf","{{picked}} / {{blocked}} rooms","{{picked}} / {{blocked}} Zimmer","Pokoje: {{picked}} / {{blocked}}"],
  ["release","release {{date}}","Freigabe {{date}}","zwolnienie {{date}}"],
  ["noRelease","no release date","kein Freigabedatum","brak daty zwolnienia"],
  ["notes","Notes","Notizen","Notatki"],
  ["allNotes","All notes","Alle Notizen","Wszystkie notatki"],
  ["newNote","New note","Neue Notiz","Nowa notatka"],
  ["notePlaceholder","Leadership note for the team","Leitungsnotiz für das Team","Notatka kierownictwa dla zespołu"],
  ["noteFooter","Leadership note","Leitungsnotiz","Notatka kierownictwa"],
  ["saveNote","Save note","Notiz speichern","Zapisz notatkę"],
  ["cancel","Cancel","Abbrechen","Anuluj"],
  ["noNotes","No leadership notes yet.","Noch keine Leitungsnotizen.","Brak notatek kierownictwa."],
  ["notesFailed","Leadership notes could not be loaded — showing the latest notes read-only.","Leitungsnotizen konnten nicht geladen werden — letzte Notizen sind schreibgeschützt.","Nie udało się wczytać notatek kierownictwa — ostatnie notatki są tylko do odczytu."],
  ["noteActions","Edit, acknowledge, delete","Bearbeiten, bestätigen, löschen","Edytuj, potwierdź, usuń"],
  ["edit","Edit","Bearbeiten","Edytuj"],
  ["acknowledge","Acknowledge","Quittieren","Potwierdź odczytanie"],
  ["acknowledged","Acknowledged","Quittiert","Potwierdzone"],
  ["delete","Delete","Löschen","Usuń"],
  ["deleteConfirm","Delete this leadership note?","Diese Leitungsnotiz löschen?","Usunąć tę notatkę kierownictwa?"],
  ["notAuthor","Only the author of the note or a manager can change it","Nur der Autor oder eine Führungskraft kann diese Notiz ändern","Tylko autor lub kierownik może zmienić tę notatkę"],
  ["noHotel","Permission required: hotel access","Berechtigung erforderlich: Hotelzugriff","Wymagane uprawnienie: dostęp do hotelu"],
  ["ackByYou","acknowledged by you","von Ihnen bestätigt","potwierdzone przez Ciebie"],
  ["refreshFailed","Refresh failed — showing the last loaded data","Aktualisierung fehlgeschlagen — zuletzt geladene Daten werden angezeigt","Odświeżanie nie powiodło się — wyświetlono ostatnie dane"],
  ["loadFailed","Unable to load the manager dashboard","Manager-Dashboard konnte nicht geladen werden","Nie udało się wczytać pulpitu kierownika"],
  ["retry","Retry","Erneut versuchen","Spróbuj ponownie"],
  ["retrying","Retrying…","Wird erneut versucht…","Ponawianie…"],
  ["degraded","Some sections could not load:","Einige Bereiche konnten nicht geladen werden:","Nie udało się wczytać niektórych sekcji:"],
  ["degradedTail","The rest of the dashboard is live; check the server logs for details.","Die übrigen Dashboard-Daten sind aktuell; Details stehen im Serverprotokoll.","Pozostałe sekcje pulpitu są aktualne; szczegóły znajdują się w logach serwera."],
  ["Acknowledge","Acknowledge","Quittieren","Potwierdź odczytanie"],
  ["Available","Available","Verfügbar","Dostępne"],
  ["Cancel","Cancel","Abbrechen","Anuluj"],
  ["Delete","Delete","Löschen","Usuń"],
  ["Edit","Edit","Bearbeiten","Edytuj"],
  ["Groups","Groups","Gruppen","Grupy"],
  ["Needs attention","Needs attention","Handlungsbedarf","Wymaga uwagi"],
  ["Notes","Notes","Notizen","Notatki"],
  ["Open","Open","Offen","Otwarte"],
  ["Retry","Retry","Erneut versuchen","Spróbuj ponownie"],
  ["Status","Status","Status","Status"],
  ["none","none","keine","brak"],
  ["Acknowledged","Acknowledged","Quittiert","Potwierdzone"],
  ["Other","Other","Sonstiges","Inne"],
  ["Loading…","Loading…","Wird geladen…","Wczytywanie…"],
  ["Total","Total","Gesamt","Razem"],
  ["Revenue","Revenue","Umsatz","Przychód"],
  ["Billing","Billing","Abrechnung","Rozliczenia"],
  ["Housekeeping","Housekeeping","Housekeeping","Housekeeping"],
  ["Reports","Reports","Berichte","Raporty"],
  ["Out of Order","Out of Order","Außer Betrieb","Wyłączony z użytkowania"],
  ["Dirty","Dirty","Schmutzig","Brudne"],
  ["Out of order","Out of order","Außer Betrieb","Wyłączone z użytku"],
  ["Departments","Departments","Abteilungen","Działy"],
  ["Performance","Performance","Leistung","Wydajność"],
  ["Details","Details","Details","Szczegóły"],
  ["Occupied","Occupied","Belegt","Zajęte"],
  ["Reserved","Reserved","Reserviert","Zarezerwowane"],
  ["Floor","Floor","Etage","Piętro"],
  ["Segment","Segment","Segment","Segment"],
  ["confirmed","confirmed","Bestätigt","Potwierdzona"],
  ["pending","pending","ausstehend","oczekujących"],
  ["cancelled","cancelled","Storniert","Anulowana"],
  ["critical","critical","Kritisch","Krytyczny"],
  ["high","high","Hoch","Wysoki"],
  ["medium","medium","Mittel","Średni"],
  ["Arrival rooms not ready","Arrival rooms not ready","Anreisezimmer nicht bereit","Pokoje przyjazdowe niegotowe"],
  ["checked-in","checked-in","Eingecheckt","Zameldowane"],
  ["checked-out","checked-out","Ausgecheckt","Wymeldowane"],
  ["Occupancy","Occupancy","Auslastung","Obłożenie"],
  ["No-shows","No-shows","Nichtanreisen","Nieprzyjazdy"],
  ["Cancellations","Cancellations","Stornierungen","Anulowania"],
  ["occupied","occupied","Belegt","Zajęty"],
  ["room","room","Zimmer","pokój"],
  ["ready","ready","bereit","gotowych"],
  ["pickup","pickup","Pickup","pickup"],
  ["start","start","Starten","Rozpocznij"],
  ["maintenance","maintenance","Wartung","Konserwacja"],
  ["available","available","Verfügbar","Dostępny"],
  ["reserved","reserved","Reserviert","Zarezerwowany"],
  ["{{count}} rooms","{{count}} rooms","{{count}} Zimmer","{{count}} pokoju"],
  ["Total Rooms","Total Rooms","Zimmer insgesamt","Pokoje łącznie"],
  ["Channels","Channels","Kanäle","Kanały"],
  ["Share","Share","Anteil","Udział"],
  ["Save note","Save note","Notiz speichern","Zapisz notatkę"],
  ["New note","New note","Neue Notiz","Nowa notatka"],
  ["Arrivals","Arrivals","Anreisen","Przyjazdy"],
  ["Departures","Departures","Abreisen","Wyjazdy"],
  ["In house","In house","Im Haus","W hotelu"],
  ["ADR","ADR","ADR","ADR"],
  ["RevPAR","RevPAR","RevPAR","RevPAR"],
  ["end","end","Ende","koniec"],
  ["On the books","On the books","Buchungsstand","Na księdze"],
  ["Room nights","Room nights","Zimmernächte","Pokojonoce"],
  ["7 days","7 days","7 Tage","7 dni"],
  ["rev","rev","Revision","wersja"],
  ["Retrying…","Retrying…","Wird erneut versucht…","Ponawianie…"],
  ["Owner","Owner","Verantwortlich","Opiekun"],
  ["Revenue today","Revenue today","Umsatz heute","Przychód dziś"],
  ["OOO","OOO","Außer Betrieb","Wyłączone z użytku"],
  ["Coverage","Coverage","Abdeckung","Pokrycie"],
  ["{{count}} departments at risk","{{count}} departments at risk","{{count}} gefährdete Abteilungen","{{count}} zagrożonego działu"],
  ["Channel","Channel","Kanal","Kanał"],
  ["View all","View all","Alle anzeigen","Zobacz wszystko"],
  ["Department","Department","Abteilung","Dział"],
  ["Open issues","Open issues","Offene Probleme","Otwarte problemy"],
  ["Live room status across all floors","Live room status across all floors","Live-Zimmerstatus auf allen Etagen","Status pokoi na żywo na wszystkich piętrach"],
  ["Guest experience","Guest experience","Gästeerlebnis","Doświadczenie gości"],
  ["Satisfaction, reviews and service recovery (last 90 days)","Satisfaction, reviews and service recovery (last 90 days)","Zufriedenheit, Bewertungen und Problemlösung (letzte 90 Tage)","Satysfakcja, opinie i rozwiązywanie problemów (ostatnie 90 dni)"],
  ["Status, workload and exceptions by department (today)","Status, workload and exceptions by department (today)","Status, Arbeitslast und Ausnahmen nach Abteilung (heute)","Status, obciążenie i wyjątki wg działów (dziś)"],
  ["Active risks requiring attention","Active risks requiring attention","Aktive Risiken mit Handlungsbedarf","Aktywne ryzyka wymagające uwagi"],
  ["Guest satisfaction","Guest satisfaction","Gästezufriedenheit","Satysfakcja gości"],
  ["vs LY","vs LY","ggü. VJ","vs UB"],
  ["vs FCST","vs FCST","ggü. Prognose","vs PROG"],
  ["Sellable","Sellable","Verkaufbar","Sprzedawalne"],
  ["By floor","By floor","Nach Etage","Według piętra"],
  ["% of total","% of total","Anteil in %","% całości"],
  ["% occupancy","% occupancy","% Auslastung","% obłożenia"],
  ["Response SLA","Response SLA","Antwort-SLA","SLA odpowiedzi"],
  ["Satisfaction","Satisfaction","Zufriedenheit","Satysfakcja"],
  ["Reviews (90d)","Reviews (90d)","Bewertungen (90 Tage)","Opinie (90d)"],
  ["open cases","open cases","offene Fälle","otwarte sprawy"],
  ["Positive","Positive","Positiv","Pozytywny"],
  ["Neutral","Neutral","Neutral","Neutralny"],
  ["Negative","Negative","Negativ","Negatywny"],
  ["At risk","At risk","Gefährdet","Zagrożone"],
  ["Workload","Workload","Arbeitslast","Obciążenie"],
  ["Excep.","Excep.","Ausn.","Wyjąt."],
  ["Req.","Req.","Erf.","Wym."],
  ["No stays in the last 28 days.","No stays in the last 28 days.","Keine Aufenthalte in den letzten 28 Tagen.","Brak pobytów z ostatnich 28 dni."],
  ["As of","As of","Stand:","Stan na"],
  ["Market ADR","Market ADR","Markt-ADR","ADR rynku"],
  ["Market RevPAR","Market RevPAR","Markt-RevPAR","RevPAR rynku"],
  ["Comp set index","Comp set index","Comp-Set-Index","Indeks comp set"],
  ["Above comp set","Above comp set","Über Comp-Set","Powyżej comp set"],
  ["Below comp set","Below comp set","Unter Comp-Set","Poniżej comp set"],
  ["Leadership brief","Leadership brief","Führungsbriefing","Brief kierowniczy"],
  ["No upcoming group blocks","No upcoming group blocks","Keine bevorstehenden Gruppenblöcke","Brak nadchodzących blokad grupowych"],
  ["Pickup vs yesterday","Pickup vs yesterday","Pickup vs. gestern","Pickup vs wczoraj"],
  ["Revenue pace","Revenue pace","Umsatzentwicklung","Tempo przychodu"],
  ["Comp Set Index","Comp Set Index","Comp-Set-Index","Comp Set Index"],
  ["Displacement","Displacement","Verdrängung","Wyparcie"],
  ["No active operational risks","No active operational risks","Keine aktiven operativen Risiken","Brak aktywnych ryzyk operacyjnych"],
  ["Enter","Enter","Öffnen","Wejdź"],
];

export const managerDashboardResources = {
  en: { ...Object.fromEntries(entries.map(([key, en]) => [key, en])), ...Object.fromEntries(managerDashboardDetailEntries.map(([key]) => [key, key])) },
  de: { ...Object.fromEntries(entries.map(([key, , de]) => [key, de])), ...Object.fromEntries(managerDashboardDetailEntries.map(([key, de]) => [key, de])) },
  pl: { ...Object.fromEntries(entries.map(([key, , , pl]) => [key, pl])), ...Object.fromEntries(managerDashboardDetailEntries.map(([key, , pl]) => [key, pl])) },
};
